import ILogoPostion from "../../../types/ILogoPostion";

export const logosPositions: ILogoPostion[] = [
    { id: "header", label: "Oben Links" },
    { id: "footer", label: "Unter dem Footer" },
    { id: "both", label: "Oben und Unten" },
    { id: "hidden", label: "Nicht anzeigen" },
];
